'use client';

import { LanguageProvider } from '@/context/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';
import BackToTop from '@/components/ui/BackToTop';
import AccessibilityWidget from '@/components/ui/AccessibilityWidget';
import AOSProvider from '@/components/providers/AOSProvider';

interface MainLayoutProps {
  children: React.ReactNode;
  showNavbar?: boolean;
  showFooter?: boolean;
}

/**
 * Client Component layout wrapper.
 * Wraps content in LanguageProvider for translations.
 * 
 * IMPORTANT: This is rendered INSIDE page components, so page-level metadata 
 * (export const metadata) is resolved BEFORE hitting this Client Component boundary.
 * This ensures metadata is properly placed in <head> for SEO.
 */
export default function MainLayout({ 
  children, 
  showNavbar = true, 
  showFooter = true 
}: MainLayoutProps) {
  return (
    <LanguageProvider>
      {showNavbar && <Navbar />}
      <AOSProvider>
        <main id="a11y-content" className="w-full">{children}</main>
      </AOSProvider>
      {showFooter && <Footer />}
      <BackToTop />
      <AccessibilityWidget />
    </LanguageProvider>
  );
}
